import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import AppRoutes from './routes';
import UpdateNotification from './components/common/UpdateNotification';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
          <Toaster position="top-right" richColors />
          <UpdateNotification />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
